import { dpprApiGet, dpprApiPut } from 'utils/http'
import httpExceptionUtil from 'utils/httpExceptionUtil'

export const fetchReport = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const putReportVerification = async (code) => {
  try {
    return await dpprApiPut({ url: `/public/email-verification/${code}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchPropertyPhoto = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/photos` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchPropertySummary = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/propertySummary` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchValuationEstimates = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/valuationEstimates` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchRatingValuation = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/ratingValuation` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchRecordOfTitleDetails = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/titleRecord` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchDisclaimer = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/disclaimer` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchCopyright = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/copyright` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchPropertyTimeline = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/propertyTimeline` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchComparableProperties = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/comparableProperties` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchLocalSchools = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/localSchools` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchMarketInsights = async (code, yearCount) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/marketInsights?yearCount=${yearCount}` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}

export const fetchMapCoordinates = async (code) => {
  try {
    return await dpprApiGet({ url: `/public/reports/code/${code}/mapPropertyCoordinates` })
  } catch (e) {
    throw httpExceptionUtil(e)
  }
}
